import React, { useState } from "react";
import {
  Button,
  Flex,
  Heading,
  Stack,
  useColorModeValue,
  Spinner,
  useToast,
} from "@chakra-ui/react";
import { FormInput } from "../FormInput";
import { resendConfirmationCode } from "../../utils/authHelpers";

export const ConfirmUser = ({
  code,
  onCodeChange,
  onConfirmCodeSubmit,
  isWorking,
  username,
}) => {
  const [isCodeResent, setIsCodeResent] = useState(false);
  const toast = useToast();

  const resendCode = async () => {
    setIsCodeResent(true);
    const res = await resendConfirmationCode(username);
    toast({
      position: "top",
      title: "Successfully sent the confirmation code.",
      status: "success",
      duration: 9000,
      isClosable: true,
    });
    setIsCodeResent(false);
  };
  return (
    <Flex
      minH={"100vh"}
      align={"center"}
      justify={"center"}
      bg={useColorModeValue("gray.50", "gray.800")}
    >
      <Stack
        spacing={4}
        w={"full"}
        maxW={"md"}
        bg={useColorModeValue("white", "gray.700")}
        rounded={"xl"}
        boxShadow={"lg"}
        p={6}
        my={12}
      >
        <Heading
          style={{
            lineHeight: "20px",
            fontSize: "18px",
            fontWeight: 500,
          }}
        >
          Enter confirmation code
        </Heading>
        <form onSubmit={onConfirmCodeSubmit}>
          <FormInput
            label="Code"
            name="code"
            type="text"
            placeholder="Code"
            inputOnChange={onCodeChange}
            value={code}
            formProps={{ isRequired: true }}
            padding="0 0 20px"
          />
          <Stack spacing={6}>
            <Button
              colorScheme="brand"
              _hover={{
                bg: "blue.500",
              }}
              type="submit"
            >
              {isWorking ? <Spinner color="#fff" /> : "Verify Account"}
            </Button>
            <Button colorScheme="brand" variant="ghost" onClick={resendCode}>
              {isCodeResent ? <Spinner color="blue.500" /> : "Resend code"}
            </Button>
          </Stack>
        </form>
      </Stack>
    </Flex>
  );
};
